import React from 'react';
import classnames from 'classnames';
import { Box, Typography } from '@material-ui/core';
import AspectRatio from 'react-aspect-ratio';

import '../../components/aspectRatio/aspect-ratio.css';
import css from './speakersPage.module.scss';
import { Photo } from '../../components/layout/pageLayout/PageLayout';
import { Link } from '../../components/elements/Elements';
import { ClassName } from '../../components/types';
import { Speaker } from '../../services/models';
import { speakerDetailedRoute } from '../../routes';

export const speakerImageRatio = 9 / 13;

export default function SpeakerCard({ className, clickable = false, item, onClick }: ClassName & {
  item: Speaker, clickable?: boolean, onClick?: () => void,
}) {
  const c = classnames(css.SpeakerCard, className, { [css.clickable]: clickable || onClick });
  const Wrapper = clickable ? Link : Box;
  return (
    <Wrapper className={c} to={speakerDetailedRoute(item.id)} onClick={onClick}>
      <AspectRatio ratio={speakerImageRatio} style={{ width: "100%" }}>
        <Photo className={classnames(css.SpeakerCard__photo, 'photo')} src={item.image} alt={item.full_name} />
      </AspectRatio>
      <Typography className={css.SpeakerCard__title}>{item.full_name}</Typography>
      {item.organization && <Typography className={css.SpeakerCard__subtitle}>{item.organization}</Typography>}
    </Wrapper>
  );
}
